import React from 'react';
import HeroSection from '../components/HeroSection';
import QuizInteraction from '../components/QuizInteraction';
import BenefitsGrid from '../components/BenefitsGrid';
import JourneyTimeline from '../components/JourneyTimeline';
import QuickBookingSection from '../components/QuickBookingSection';
import ReferEarnWidget from '../components/ReferEarnWidget';
import TrustCredibility from '../components/TrustCredibility';
import StickyCTA from '../components/StickyCTA';

const Home = () => {
  return (
    <div className="min-h-screen">
      <HeroSection />
      <QuizInteraction />
      <BenefitsGrid />
      <JourneyTimeline />
      <QuickBookingSection />
      <TrustCredibility />
      <ReferEarnWidget />
      <StickyCTA />
    </div>
  );
};

export default Home;
